// extracted by mini-css-extract-plugin
module.exports = {"postTo":"PostTo_postTo__3-fZT","form":"PostTo_form__beVfC","linkedin":"PostTo_linkedin__3yg_t","facebook":"PostTo_facebook__1seC9","twitter":"PostTo_twitter__3bkZA"};